import { useCallback } from "react"
import { useLocation, useNavigate } from "react-router"

interface UseScrubQuerystringOptions {
  paramToScrub?: string | string[]
}

export const useScrubQuerystring = ({
  paramToScrub,
}: UseScrubQuerystringOptions = {}) => {
  // DEV: We scrub to prevent leaking params via HTTP referer, https://github.com/django/django/blob/8a7ac78b706797a03d26b88eddb9d1067ed35b66/django/contrib/auth/views.py#L280-L288
  const navigate = useNavigate()
  const location = useLocation()

  return useCallback(() => {
    if (paramToScrub) {
      // If a specific parameter is provided, only remove that one
      const searchParams = new URLSearchParams(location.search)

      const paramsToScrub = Array.isArray(paramToScrub)
        ? paramToScrub
        : [paramToScrub]

      paramsToScrub.forEach((param) => {
        if (searchParams.has(param)) {
          searchParams.delete(param)
        }
      })

      navigate(
        {
          pathname: location.pathname,
          search: searchParams.toString(),
        },
        {
          state: location.state,
        }
      )
    } else {
      // Original functionality: remove all query parameters
      navigate(location.pathname, {
        state: location.state,
      })
    }
  }, [navigate, location, paramToScrub])
}
